import { default as Icon, IconName as IconNameIcon } from './icon'

export type IconName = IconNameIcon

export default Icon
